export default __webpack_public_path__ + "static/media/webinar1.3ca48baf.jpeg";